import React, { useRef } from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-extraneous-dependencies
import SignaturePadWrapper from "react-signature-pad-wrapper";

export default function SignaturePadInput({ value, onChange }) {
  const sigPad = useRef();

  const handleClear = () => {
    sigPad.current.clear();
    onChange("");
  };

  const handleSave = () => {
    if (!sigPad.current.isEmpty()) {
      const url = sigPad.current.toDataURL("image/png");
      onChange(url);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box
        sx={{
          width: 400,
          height: 200,
          border: "2px solid #aaa",
          borderRadius: "8px",
          background: "#fff",
          mb: 1,
          overflow: "hidden",
        }}
      >
        <SignaturePadWrapper
          ref={sigPad}
          width={400}
          height={200}
          penColor="black"
          backgroundColor="white"
          options={{
            minWidth: 2,
            maxWidth: 4,
          }}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button onClick={handleClear} variant="outlined" size="small">
          Clear
        </Button>
        <Button onClick={handleSave} variant="contained" size="small" color="primary">
          Save Signature
        </Button>

      </Box>
      {value && (
        <img
          src={value}
          alt="Signature Preview"
          style={{
            border: "1px solid #ccc",
            marginTop: 8,
            maxWidth: 200,
            maxHeight: 120,
            borderRadius: 6,
            boxShadow: "0 2px 4px #0001",
          }}
        />
      )}
    </Box>
  );
}

SignaturePadInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
